import { useEffect, useState } from "react"
import Application from "services/applications/Application.service"

const STATIC_FILES = process.env.REACT_APP_STATIC_FILES

const loggedInUser = JSON.parse(localStorage.getItem("authUser"))
const appService = new Application(loggedInUser)

const ViewAttachments = props => {
  const [attachments, setattachments] = useState([])

  // const download = (path, name) => {
  //   appService
  //     .downloadAttachment(path)
  //     .then(response => {
  //       response.arrayBuffer().then(function (buffer) {
  //         const url = window.URL.createObjectURL(new Blob([buffer]))
  //         const link = document.createElement("a")
  //         link.href = url
  //         link.setAttribute("download", name)
  //         document.body.appendChild(link)
  //         link.click()
  //         link.remove()
  //       })
  //     })
  //     .catch(err => {
  //       console.log(err)
  //     })
  // }

  // New implementation 2025
    const download = async (id, name) => {
    try {
      const response = await appService.downloadAttachment(id);
      // console.log(response)

      const blob = new Blob([response]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    let atts = []
    let kount = 0
    props.attachments.forEach(attach => {
      atts.push(
        <tr key={kount}>
          <td>{attach.description}</td>
          <td>{attach.file_name}</td>
          <td>
            <a href="#" onClick={e => download(attach.id, attach.file_name)}>
              <i
                className="fas fa-cloud-download-alt"
                title="Download"
                style={{ color: "green" }}
              ></i>
            </a>
          </td>
        </tr>
      )
      kount++
    })
    setattachments(atts)
  }, [props.attachments])

  return (
    <div>
      <table className="table table-striped table-responsive">
        <thead>
          <tr>
            <th>Description</th>
            <th>Uploaded File</th>
            <th>Download</th>
          </tr>
        </thead>

        <tbody>{attachments}</tbody>
      </table>
    </div>
  )
}

export default ViewAttachments
